import { render } from "./NavItems.vue?vue&type=template&id=fc9dd9a4&scoped=true"
const script = {}

import "./NavItems.vue?vue&type=style&index=0&id=fc9dd9a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc9dd9a4"]])

export default __exports__